module.exports = __webpack_public_path__ + "static/media/close-chest.33ccf398.mp3";